import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectTabService {
  private activeTabSubject = new BehaviorSubject<string>(null);
  activeTab$: Observable<string> = this.activeTabSubject.asObservable();

  constructor() { }

  setActiveTab(tabKey: string) {
    this.activeTabSubject.next(tabKey);
  }

  getActiveTab(): string {
    return this.activeTabSubject.getValue();
  }
}
